
define('tpl!taoQtiItem/qtiCreator/tpl/outcomeEditor/panel', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<div class=\"qti-outcome-editor panel\">\n    <hr/>\n    <h3 class=\"has-icon\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Outcome Declarations", options) : helperMissing.call(depth0, "__", "Outcome Declarations", options)))
    + "</h3>\n    <span class=\"icon-help tooltipstered\" data-tooltip=\"~ .tooltip-content\" data-tooltip-theme=\"info\"></span>\n    <span class=\"tooltip-content\">here you can provide scoring aspects for manual scoring/marking, e.g. CONTENT, GRAMMAR, SPELLING</span>\n    <div class=\"outcomes\">\n        ";
  if (helper = helpers.listing) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.listing); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <a href=\"#\" class=\"adder feedbackRule-add\">Add an outcome</a>\n</div>";
  return buffer;
  });
});

